import { EInstitutionType } from '@ucheba/store/institutions/item/types'

// Получаем название учреждения в зависимости от типа учреждения

export const getNameInstitution = (type: EInstitutionType): string => {
  switch (type) {
    case EInstitutionType.University:
      return 'вуз'
    case EInstitutionType.College:
      return 'колледж'
    default:
      return ''
  }
}
